import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getPageLinkByNodeId, useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { cardStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsLineCard";
import Button from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LazyImage from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";

export interface InfoLinkFieldValue {
    type: "InfoLink";
    value: string;
}

interface InfoCardModel {
    fields: {
        image: string;
        title: string;
        description: string;
        link: InfoLinkFieldValue;
        linkTitle: string;
        background: string;
    };
}

const enum fields {
    infoCards = "infoCards",
    image = "image",
    title = "title",
    description = "description",
    descriptionBackground = "descriptionBackground",
    link = "link",
    linkTitle = "linkTitle",
    infoCardTitle = "infoCardTitle",
    RedirectionButton = "RedirectionButton",
    RedirectionButtonTitle = "RedirectionButtonTitle",
    background = "background",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.infoCards]: InfoCardModel[];
        infoCardTitle: string;
        background: string;
        descriptionBackground: string;
        RedirectionButtonTitle: string;
        RedirectionButton: LinkFieldValue;
    };
}
export interface MappedLink {
    title?: string;
    url?: string;
    image?: string;
    description?: string;
    descriptionBackground?: string;
    link?: InfoLinkFieldValue;
    linkTitle?: string;
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    const {
        fields: { infoCards },
    } = ownProps;
    const mappedInfoCards = [];
    for (const card of infoCards) {
        let mappedLink: MappedLink | undefined;
        // let readonlyPageLink : string[] | undefined;
        const readonlyPageLink = getPageLinkByNodeId(state, card.fields.link.value) || undefined;
        // const readonlyPageLink = getPageLinkByNodeId(state, card.fields.link.value);
        const linkData = readonlyPageLink || undefined;
        if (linkData) {
            mappedLink = { ...card.fields };
            mappedLink.url = linkData.url;
        }
        mappedInfoCards.push(mappedLink);
    }
    return {
        mappedInfoCards,
    };
};
type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface IInfoCardsStyles {
    container?: GridContainerProps;
    infoCard?: GridItemProps;
    customflyImgWrapper?: InjectableCss;
    customDescriptionText?: TypographyPresentationProps;
    customFlyTitle?: TypographyPresentationProps;
    infocardcontainer?: InjectableCss;
    infocardWraper?: InjectableCss;
    buttonStyle?: LinkPresentationProps;
    infoCardTitle?: TypographyPresentationProps;
}

export const infoCardsStyles: IInfoCardsStyles = {
    infoCardTitle: {
        variant: "h2",
        css: css`
            text-align: center;
            text-transform: uppercase;
            font-size: 2rem;
            margin: 30px 0px;
            color: ${getColor("primary.main")};
        `,
    },
    infocardcontainer: {
        css: css`
            padding: 30px 0px;
            max-width: 1300px;
            margin: 0 auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            max-width: 100% !important;
                            padding: 27px 0px;
                        `,
                        css`
                            max-width: 100% !important;
                            padding: 27px 0px;
                        `,
                        css`
                            max-width: 720px !important;
                            padding: 30px 0px 60px;
                        `,
                        css`
                            max-width: 960px !important;
                            padding: 30px 0px 60px;
                        `,
                        css`
                            max-width: 1300px !important;
                            padding: 30px 0px 60px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    container: {
        gap: 38,
        css: css`
            align-items: center;
            margin: 0 auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            max-width: 100% !important;
                            padding: 0 30px;
                        `,
                        css`
                            max-width: 100% !important;
                            padding: 0 30px;
                        `,
                        css`
                            max-width: 720px !important;
                            padding: 0 0px;
                        `,
                        css`
                            max-width: 960px !important;
                            padding: 0 0px;
                        `,
                        css`
                            max-width: 1300px !important;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    infoCard: {
        width: [12, 6, 6, 3, 3],
        css: css`
            // margin-right: 38px !important;
            // :nth-child(3n) {
            //     margin-right: 0px !important;
            // }
            /* :only-child {
                margin-right: 0px;
                //width: 230px;
                img {
                    height: 200px;
                    width: 100%;
                    object-fit: cover;
                }
            } */
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 15px;
                        `,
                        css`
                            padding: 15px;
                        `,
                        css`
                            padding: 19px;
                        `,
                        css`
                            padding: 19px;
                        `,
                        css`
                            padding: 19px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    infocardWraper: {
        css: css`
            border-bottom: 5px solid ${getColor("primary.main")};
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            padding-bottom: 20px;
            box-shadow: 1px 7px 11px 0px rgb(0 0 0 / 13%);
        `,
    },
    customflyImgWrapper: {
        css: css`
            box-sizing: border-box;
            width: 100%;
            height: 180px;
            overflow: hidden;
            div[class^="LazyImageStyle"] {
                width: 100%;
                height: auto;
            }
            img {
                height: 180px;
                width: 100%;
                object-fit: cover;
            }
        `,
    },
    customFlyTitle: {
        variant: "p",
        css: css`
            color: #33333a;
            font-size: 23px;
            font-weight: 600;
            letter-spacing: 0;
            line-height: 30px;
            margin-bottom: 20px;
            padding-left: 20px;
            padding-right: 20px;
            margin-top: 7px;
            text-transform: uppercase;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            max-height: 91px;
            height: 60px;
        `,
    },
    customDescriptionText: {
        variant: "p",
        css: css`
            color: #33333a;
            font-size: 16px;
            font-weight: 300;
            letter-spacing: 0;
            line-height: 24px;
            margin-bottom: 17px;
            padding-left: 20px;
            padding-right: 20px;
        `,
    },
    buttonStyle: {
        css: css`
            margin-bottom: 24px;
            span {
                background-color: transparent !important;
                color: ${getColor("primary.main")} !important;
                font-size: 14px;
                font-weight: bold;
                letter-spacing: 2px;
                line-height: normal;
                text-transform: uppercase;
                padding: 10px 0px;
                &:hover {
                    text-decoration: underline;
                }
            }
        `,
    },
};

const styles = infoCardsStyles;

const DescriptionWrapper = styled.div<{ backgroundColor: string }>`
    background-color: ${props => props.backgroundColor};
    height: 100%;
`;

const InfoCards: React.FC<Props> = ({ id, fields, mappedInfoCards }) => {
    const { url } = useGetLink(fields.RedirectionButton);

    return (
        <>
            <StyledWrapper style={{ backgroundColor: fields.background }}>
                <StyledWrapper {...styles.infocardcontainer}>
                    {fields.infoCardTitle ? (
                        <Typography {...styles.infoCardTitle}>{fields.infoCardTitle}</Typography>
                    ) : null}

                    {mappedInfoCards?.length > 0 ? (
                        <GridContainer {...styles.container}>
                            {mappedInfoCards?.map((card, index) => {
                                return (
                                    <GridItem
                                        id="each-column"
                                        // eslint-disable-next-line react/no-array-index-key
                                        key={index}
                                        {...styles.infoCard}
                                    >
                                        <DescriptionWrapper backgroundColor={fields.descriptionBackground}>
                                            <StyledWrapper {...styles.infocardWraper}>
                                                {card && card?.image && (
                                                    <StyledWrapper {...styles.customflyImgWrapper}>
                                                        <LazyImage src={card?.image} altText={card?.title} />
                                                    </StyledWrapper>
                                                )}
                                                {card && card?.title && (
                                                    <Typography {...styles.customFlyTitle}>{card?.title}</Typography>
                                                )}
                                                {card && card?.description && (
                                                    <Typography {...styles.customDescriptionText}>
                                                        {card?.description}
                                                    </Typography>
                                                )}
                                                {card && card?.url && (
                                                    <StyledWrapper
                                                        css={css`
                                                            padding: 0 20px;
                                                            margin-top: auto;
                                                        `}
                                                    >
                                                        <Link {...styles.buttonStyle} href={card?.url}>
                                                            {card?.linkTitle}
                                                        </Link>
                                                    </StyledWrapper>
                                                )}
                                            </StyledWrapper>
                                        </DescriptionWrapper>
                                    </GridItem>
                                );
                            })}
                        </GridContainer>
                    ) : null}
                </StyledWrapper>
            </StyledWrapper>
            <StyledWrapper style={{ background: `linear-gradient(to bottom, ${fields.background} 50%, #fff 50%)` }}>
                <Zone zoneName="Current Openings" contentId={id} />
            </StyledWrapper>
        </>
    );
};

const membersList: WidgetModule = {
    component: connect(mapStateToProps)(InfoCards),
    definition: {
        group: "Common",

        fieldDefinitions: [
            {
                name: fields.infoCards,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields) => {
                    return item.fields.title;
                },
                defaultValue: [],
                fieldType: "Translatable",

                sortOrder: 2,
                fieldDefinitions: [
                    {
                        name: fields.title,
                        displayName: "Title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        sortOrder: 0,
                    },
                    {
                        name: fields.image,
                        displayName: "Photo",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                        sortOrder: 1,
                    },
                    {
                        name: fields.description,
                        displayName: "Description",
                        editorTemplate: "MultilineTextField",
                        defaultValue: "",
                        sortOrder: 6,
                    },

                    {
                        name: fields.link,
                        displayName: "Link",
                        editorTemplate: "LinkField",
                        defaultValue: { type: "Page", value: "" },
                        sortOrder: 4,
                    },

                    {
                        name: fields.linkTitle,
                        displayName: "Link Title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        sortOrder: 5,
                    },
                ],
            },
            {
                name: fields.infoCardTitle,
                displayName: "Info Card Title",
                editorTemplate: "TextField",
                defaultValue: "",
                sortOrder: 0,
                fieldType: "Translatable",
            },
            {
                fieldType: "Translatable",
                name: fields.background,
                displayName: "Component Background",
                editorTemplate: "ColorPickerField",
                defaultValue: "white",
                sortOrder: 1,
            },
            {
                fieldType: "Translatable",
                name: fields.descriptionBackground,
                displayName: "Description Background",
                editorTemplate: "ColorPickerField",
                defaultValue: "white",
                sortOrder: 1,
            },
            {
                fieldType: "General",
                name: fields.RedirectionButton,
                displayName: "Redirection Link",
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
                sortOrder: 2,
            },
            {
                fieldType: "Translatable",
                name: fields.RedirectionButtonTitle,
                displayName: "Link Title",
                editorTemplate: "TextField",
                defaultValue: "",
                sortOrder: 3,
            },
        ],
    },
};

export default membersList;
